'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToggleButton_unstable", {
    enumerable: true,
    get: function() {
        return useToggleButton_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToggleState = require("../../utils/useToggleState");
const _useButton = require("../Button/useButton");
const useToggleButton_unstable = (props, ref)=>{
    const buttonState = (0, _useButton.useButton_unstable)(props, ref);
    return (0, _useToggleState.useToggleState)(props, buttonState);
};
